import React from 'react';
import { Spinner } from '@pushwoosh/kit-spinner';
import { ButtonPropsToButtonBoxMap, SpinnerSizeByButtonSizeMap } from './button.maps';
import { ButtonIcon, ButtonSpinner, ButtonContent } from './button.styles';
export function Button(props) {
  const {
    type = 'button',
    boxRef,
    color,
    view = 'shape',
    size = 'field',
    isDisabled,
    isLoading,
    isOpen,
    icon,
    rightIcon,
    children,
    ...rest
  } = props;
  if (!color) {
    console.error(`[Button]: required prop color "${color}" is not set`);
    return null;
  }
  const ButtonBox = ButtonPropsToButtonBoxMap[color][view][size];
  if (!ButtonBox) {
    console.error(`[Button]: cannot render with color "${color}" and size "${size}" and view "${view}"`);
    return null;
  }
  const isShowOverlaySpinner = !!children && !icon && view !== 'ghost' && isLoading;
  return React.createElement(ButtonBox, {
    ...rest,
    type: type,
    disabled: isDisabled,
    "$isDisabled": isDisabled,
    "$isLoading": isLoading,
    "$isOpen": isOpen,
    "$hc": isShowOverlaySpinner,
    "$hasLeftIcon": !!icon,
    "$hasRightIcon": !!rightIcon,
    "$hasContent": !!children,
    ref: boxRef
  }, icon && React.createElement(ButtonIcon, null, isLoading ? React.createElement(Spinner, {
    size: SpinnerSizeByButtonSizeMap[size]
  }) : icon), children && React.createElement(ButtonContent, null, React.createElement("div", null, children)), rightIcon && React.createElement(ButtonIcon, null, rightIcon), isShowOverlaySpinner && React.createElement(ButtonSpinner, null, React.createElement(Spinner, {
    color: "danger",
    size: SpinnerSizeByButtonSizeMap[size]
  })));
}